<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>波次分播</div>
    </div>
    <el-row class="filter">
      <el-col>
        <el-collapse-transition>
          <div>
            <div
              style="
                background: #f3f3f3;
                height: 50px;
                line-height: 50px;
                padding: 0 25px;
                display: flex;
                align-items: center;
                justify-content: space-between;
              "
            >
              <el-select
                v-model="type"
                placeholder="分播类型"
                style="width: 150px"
                @change="setType"
              >
                <el-option
                  v-for="item in types"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                ></el-option>
              </el-select>
              <h1
                v-if="type == 'wave_picking' && resData.is_show_4 > 0"
                style="font-size: 36px"
              >
                多件多波可用:{{ resData.gk_num_4 }}
              </h1>
              <h1
                v-if="type == 'wave_picking' && resData.is_show_5 > 0"
                style="font-size: 36px"
              >
                多件少波可用:{{ resData.gk_num_5 }}
              </h1>

              <h1
                v-if="type == 'pg' || type == 'supply' || type == 'summary'"
                style="font-size: 36px"
              >
                可用格口:{{ resData.gk_num }}
              </h1>
              <h1 v-if="type == constantMap.hg" style="font-size: 36px">
                空闲可用格口数:{{ freeGridCount }}
              </h1>

              <el-select
                v-model="form.floor"
                placeholder="层数"
                style="width: 150px"
                @change="setFloor"
              >
                <el-option :label="'全部'" :value="0"></el-option>
                <el-option :label="'第一层'" :value="1"></el-option>
                <el-option :label="'第二层'" :value="2"></el-option>
              </el-select>
              <el-select
                v-if="type == constantMap.hg"
                v-model="form.sort"
                placeholder="选择排序方式"
                style="width: 150px"
                @change="setSortType"
              >
                <el-option
                  v-for="item in constantMap.SORT_TYPES"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-button
                style="margin-left: 10px"
                type="primary"
                size="mini"
                @click="refreshData"
                >刷新页面</el-button
              >
              <span>最后刷新时间:{{ resData.time }}</span>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>

    <!-- 表格 -->

    <div v-if="type == 'wave_picking'" style="margin-bottom: 0; width: 100%">
      <el-button v-if="resData.cut_data.length > 0" type="primary" plain>
        拣货任务分播</el-button
      >
      <div v-for="item in resData.cut_data" :key="item.cut_no">
        <div
          style="
            width: 20%;
            float: left;
            height: 10%;
            margin: 0 auto;
            margin-left: 1%;
            margin-top: 10px;
            border: 1px solid #3a8ee6;
            text-align: center;
          "
        >
          <p class="box_p">
            <span style="float: left; margin-left: 15px"
              >拣货单号:{{ item.cut_no }}</span
            >
          </p>
          <br />
          <p class="box_p">
            <span style="float: left; margin-left: 15px"
              >拣货方式:{{ item.assignment_type_text }} 波次类型:常规</span
            >
          </p>
          <br />
          <br />
          <p class="box_p">
            <span style="float: left; margin-left: 15px"
              >已播/已拣/所需:{{ item.cut_num }}/{{ item.sm_num }}/{{
                item.wave_picking_num
              }}</span
            ><span style="float: right; margin-right: 15px"
              >{{ item.cut_time }}/s</span
            >
          </p>
          <br />
          <p>
            <el-button
              style="float: left; margin-left: 15px; margin-bottom: 15px"
              type="success"
              size="mini"
              @click="showGrid(item.cut_no, 1)"
              >查看格口</el-button
            >
            <el-button
              style="float: right; margin-right: 15px"
              type="danger"
              size="mini"
              @click="stopCut(item.cut_no, 1)"
              >结束分播</el-button
            >
          </p>
        </div>
      </div>
    </div>
    <div
      v-if="type == 'wave_picking'"
      style="margin-bottom: 0; width: 100%; float: left; margin-top: 20px"
    >
      <el-button v-if="resData.cut_data2.length > 0" type="primary" plain>
        汇总分播</el-button
      >
      <div v-for="item in resData.cut_data2" :key="item.cut_no">
        <div
          style="
            width: 20%;
            float: left;
            height: 10%;
            margin: 0 auto;
            margin-left: 1%;
            margin-top: 10px;
            border: 1px solid #3a8ee6;
            text-align: center;
          "
        >
          <p class="box_p">
            <span style="float: left; margin-left: 15px"
              >汇总号:{{ item.cut_no }}</span
            >
          </p>
          <br />
          <p class="box_p">
            <span style="float: left; margin-left: 15px"
              >拣货方式:{{ item.type_text }}汇总 波次类型:{{
                item.type_text
              }}</span
            >
          </p>
          <br />
          <br />
          <p class="box_p">
            <span style="float: left; margin-left: 15px"
              >已播/已拣/所需:{{ item.cut_num }}/{{ item.sm_num }}/{{
                item.wave_picking_num
              }}</span
            ><span style="float: right; margin-right: 15px"
              >{{ item.cut_time }}/s</span
            >
          </p>
          <br />
          <p>
            <el-button
              style="float: left; margin-left: 15px; margin-bottom: 15px"
              type="success"
              size="mini"
              @click="showGrid(item.cut_no, 2)"
              >查看格口</el-button
            >
            <el-button
              style="float: right; margin-right: 15px"
              type="danger"
              size="mini"
              @click="stopCut(item.cut_no, 2)"
              >结束分播</el-button
            >
          </p>
        </div>
      </div>
    </div>
    <div
      v-if="type == 'wave_picking'"
      style="margin-bottom: 0; width: 100%; float: left; margin-top: 20px"
    >
      <el-button v-if="resData.cut_data3.length > 0" type="primary" plain>
        中分任务分播</el-button
      >
      <div v-for="item in resData.cut_data3" :key="item.cut_no">
        <div
          style="
            width: 20%;
            float: left;
            height: 10%;
            margin: 0 auto;
            margin-left: 1%;
            margin-top: 10px;
            border: 1px solid #3a8ee6;
          "
        >
          <p class="box_p">
            <span style="float: left; margin-left: 15px"
              >中分任务:{{ item.cut_no }}</span
            >
          </p>
          <br />
          <p class="box_p">
            <span style="float: left; margin-left: 15px"
              >拣货方式:{{ item.picking_type }} 波次类型:{{
                item.wave_type
              }}</span
            >
          </p>
          <br />
          <br />
          <p class="box_p">
            <span style="float: left; margin-left: 15px"
              >已播/已拣/所需:{{ item.cut_num }}/{{ item.sm_num }}/{{
                item.wave_picking_num
              }}</span
            ><span style="float: right; margin-right: 15px"
              >{{ item.cut_time }}/s</span
            >
          </p>
          <br />
          <p>
            <el-button
              style="float: left; margin-left: 15px; margin-bottom: 15px"
              type="success"
              size="mini"
              @click="showGrid(item.cut_no, 3)"
              >查看格口</el-button
            >
            <el-button
              style="float: right; margin-right: 15px"
              type="danger"
              size="mini"
              @click="stopCut(item.cut_no, 3)"
              >结束分播</el-button
            >
          </p>
        </div>
      </div>
    </div>

    <div
      v-if="['pg', 'supply', 'summary'].includes(type)"
      style="margin-bottom: 0; width: 100%; background: #6f7180"
    >
      <div v-if="resData.all_num">
        <div
          style="
            width: 20%;
            float: left;
            height: 10%;
            margin: 0 auto;
            margin-left: 1%;
            margin-top: 10px;
            border: 1px solid #3a8ee6;
            text-align: center;
          "
        >
          <h3>
            <p class="box_p">
              <span style="float: left; margin-left: 15px"
                >分播总数:{{ resData.all_num }}</span
              ><br />
            </p>
          </h3>
          <p class="box_p">
            <span style="float: left; margin-left: 15px"
              >异常数量:{{ resData.yc_num }}</span
            ><br />
          </p>
          <p class="box_p">
            <span style="float: left; margin-left: 15px"
              >占用格口:{{ resData.grid_num }}</span
            ><br />
          </p>
          <p class="box_p">
            <span style="float: left; margin-left: 15px"
              >{{ resData.cut_time }}/s</span
            >
            <el-button
              style="float: right; margin-right: 15px; margin-bottom: 10px"
              type="danger"
              size="mini"
              @click="stopCut('', 0)"
              >结束分播</el-button
            >
          </p>
        </div>
      </div>
    </div>

    <div v-if="type === constantMap.hg">
      <div style="padding-bottom: 12px">
        <el-button type="danger" @click="handleEndGrid()">
          结束全部分播
        </el-button>
        <el-button type="primary" @click="handleBatchEndGrid()">
          批量结束分播
        </el-button>
      </div>
      <el-row :gutter="8">
        <el-col
          v-for="item in resData"
          :key="item.grid_id"
          :md="8"
          :lg="6"
          :xl="4"
          style="margin-bottom: 8px"
        >
          <el-card>
            <template #header>
              <el-row type="flex" justify="space-between" align="bottom">
                <span style="font-weight: bold"
                  ><el-checkbox v-model="gridIds" :label="item.grid_id">
                    <span style="display: none">{{
                      item.grid_id
                    }}</span></el-checkbox
                  >{{ item.grid_no }}</span
                >
                <span style="font-size: 14px">{{ item.cut_time }}/s</span>
              </el-row>
            </template>
            <div
              v-if="item.is_single_grid === '1'"
              style="padding-bottom: 12px"
            >
              单件格口:
              {{ item.surpass_summary_id }}
            </div>
            <div v-else style="padding-bottom: 12px">
              中分编码:{{ item.hg_code }} {{ item.hg_show_id }}-{{
                item.the_sort
              }}
            </div>
            <div style="padding-bottom: 12px">已播: {{ item.cut_num }}件</div>
            <el-row type="flex" justify="space-between">
              <el-button
                v-if="item.is_single_grid !== '1'"
                type="success"
                size="small"
                @click="showGrid('', 4, item.grid_id)"
              >
                查看格口
              </el-button>
              <el-button
                type="danger"
                size="small"
                @click="handleEndGrid(item)"
              >
                结束分播
              </el-button>
            </el-row>
          </el-card>
        </el-col>
      </el-row>
    </div>

    <el-dialog title="详情" :visible.sync="girdVisible">
      <el-table :data="infoDetail">
        <el-table-column
          property="wave_picking_no"
          label="波次号"
          align="center"
          width="150"
        ></el-table-column>
        <el-table-column
          v-if="type !== constantMap.hg"
          property="grid_no"
          label="格口"
          align="center"
          width="120"
        ></el-table-column>
        <el-table-column prop="cut_dbids" label="打标ID"> </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import {
  postBatchStopCut,
  postGetFreeGridCount,
} from "@/openapi/erp/deviceCut.js";

const constantMap = Object.freeze({
  hg: "hg", // 中分位
  SORT_TYPES: [
    {
      value: "0",
      label: "默认排序",
    },
    {
      value: "1",
      label: "分播时间",
    },
    {
      value: "2",
      label: "分播数量",
    },
  ],
});
export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.initData();
    });
  },
  beforeRouteLeave(to, from, next) {
    clearInterval(this.timer);
    next();
  },
  data() {
    return {
      constantMap,
      init_type: "",
      type: "",
      types: [],
      resData: {
        gk_num: 0,
      },
      form: {
        summary_no: "",
        box_no: "",
        dbid: "",
        sort: "0", // 默认排序
        floor: 0, // 默认层数
      },
      loading: false,
      status: "",
      curPage: 1,
      filterFold: false,
      wave_picking: [],
      cur_wave: "",
      voice: "",
      timer: null,
      girdVisible: false,
      infoDetail: [],
      showGridModal: false,
      freeGridCount: 0, // 空闲格口数量
      gridIds: [], // 批量结束分播
    };
  },
  computed: {
    filteredForm() {
      // eslint-disable-next-line no-restricted-syntax
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  mounted() {
    this.timer = setInterval(() => {
      this.refreshData();
    }, 5000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },

  created() {
    this.getFreeGridCount();
  },
  methods: {
    setType(val) {
      this.$http.post("/erp/DeviceCut/setType", { type: val }).then((res) => {
        if (res.data.code !== 200) {
          this.type = this.init_type;
          this.$message.error(res.data.msg);
        } else {
          this.init_type = val;
          this.$message.success(res.data.msg);
        }
      });
    },
    showGrid(summaryNo, type, gridId) {
      this.$http
        .post("/erp/DeviceCut/showGrid", {
          summary_no: summaryNo,
          grid_id: gridId,
          type,
        })
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.girdVisible = true;
            this.infoDetail = res.data.data.data;
          }
        });
    },
    // 获取设备分播的设置
    initData() {
      this.$http
        .post("/erp/DeviceCut/getInitData", this.filteredForm)
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.init_type = res.data.data.init_type;
            this.types = res.data.data.types;
            this.type = this.init_type;
            this.refreshData();
          }
        });
    },
    refreshData() {
      this.getFreeGridCount();
      this.fetchData();
    },
    fetchData() {
      this.$http
        .post("/erp/DeviceCut/getCutData", this.filteredForm)
        .then((res) => {
          setTimeout(() => {
            this.loading = false;
          }, 200);
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.resData = res.data.data;
          }
        });
    },
    stopCut(summaryNo, type) {
      this.$http
        .post("/erp/DeviceCut/stopCut", {
          summary_no: summaryNo,
          type,
        })
        .then((res) => {
          setTimeout(() => {
            this.loading = false;
          }, 200);
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.$message.success(res.data.msg);
          }
        });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleEndGrid(item = {}) {
      this.$confirm(
        item.grid_id ? "该格口确认结束分播吗？" : "全部格口确认结束分播吗？",
        "提示",
        {}
      ).then(() => {
        this.$http
          .post(
            "/erp/DeviceCut/stopCut",
            item.grid_id ? { grid_id: item.grid_id } : {}
          )
          .then((res) => {
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
            } else {
              this.$message.success("结束成功");
              this.refreshData();
            }
          });
      });
    },
    getFreeGridCount() {
      postGetFreeGridCount().then((res) => {
        this.freeGridCount = res.count || 0;
      });
    },
    handleBatchEndGrid() {
      if (this.gridIds.length === 0) {
        this.$message.error("请选择格口号~");
        return;
      }
      const params = { grid_ids: this.gridIds };
      postBatchStopCut(params, { useDataField: false })
        .then((res) => {
          this.$message.success(res.data.msg);
        })
        .catch((err) => {
          console.log("err: ", err);
          this.$message.success("批量结束分播失败");
        })
        .finally(() => {
          this.gridIds = [];
        });
    },
    setFloor(val) {
      this.form.floor = val;
      this.refreshData();
    },
  },
};
</script>

<style scoped>
.summary_box_g {
  background-color: yellow;
}

.summary_box_r {
  background-color: green;
}

.summary_box_yc {
  background-color: red;
}

.box_p {
  margin-top: 10px;
  margin-bottom: 10px;
}

.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/wavepicking/DeviceCut.vue